export default "__VITE_ASSET__Bgc8ztVK__"